
class TreeHelper {
  static normalizeCheckboxCategory = (element, className = 'isActive') => {
    element.label = `${element.label} (${element.id})`;
    element.value = `${element.value}`;

    if (element.visible === true) {
      element.className = className;
    }
  };

  static normalizeCheckboxCategoriesTree = (parentElement, categoriesParentsMap) => {
    TreeHelper.normalizeCheckboxCategory(parentElement);
    if (!parentElement.children) {
      return;
    }

    parentElement.children.map((child) => {
      categoriesParentsMap[child.value] = parentElement.value;
      TreeHelper.normalizeCheckboxCategoriesTree(child, categoriesParentsMap);
    });
  };

  static setExpandedCategories = (categoryId, expandedCategories, categoriesParentsMap) => {
    expandedCategories.push(categoryId);
    const parentCategoryId = categoriesParentsMap[categoryId] || null;
    if (parentCategoryId) {
      TreeHelper.setExpandedCategories(parentCategoryId, expandedCategories, categoriesParentsMap);
    }
  };

  static searchCategoriesTree = (category, searchValue, expandedCategories, categoriesParentsMap) => {
    if (searchValue.length && category.label.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1) {
      if (!category.className || category.className.indexOf('isMatch') === -1) {
        category.className += ` isMatch`;
      }

      TreeHelper.setExpandedCategories(category.value, expandedCategories, categoriesParentsMap);

    } else if (typeof category.className === 'string') {
      category.className = category.className.replace(/isMatch/gi, '');
    }

    if (!category.children) {
      return category;
    }

    category.children.map((child) => {
      TreeHelper.searchCategoriesTree(child, searchValue, expandedCategories, categoriesParentsMap);
    });

    return category;
  };

  static internalFormatTreeToList(categories, results) {
    categories.forEach(category => {
      results[category.id] = { ...category, children: category.children.map(c => c.id) };

      if (category.children) {
        TreeHelper.internalFormatTreeToList(category.children, results);
      }
    });
  }

  static formatTreeToList(categoriesTree) {
    const results = {};

    TreeHelper.internalFormatTreeToList(categoriesTree, results);

    return results;
  }

  static findParent(treeData, parent_id) {
    let parent = null;
    for (let i = 0; i < treeData.length; i++) {
      if (treeData[i].id === parent_id) {
        return treeData[i];
      }

      if (treeData[i].children) {
        parent = this.findParent(treeData[i].children, parent_id);
        if (parent) {
          return parent;
        }
      }
    }

    return false;
  }
}

export default TreeHelper;



// WEBPACK FOOTER //
// ./utils/TreeHelper.js